import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import { TravelAppBar } from './components/TravelAppBar';
import { GlobalTooltip } from './components/GlobalTooltip';
import PrivateRoute from './routes/PrivateRoute';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/auth/AuthCallback';
import SilentRenew from './pages/auth/SilentRenew';
import TravelsPage from './pages/TravelsPage';
import VouchersPage from './pages/VouchersPage';
import HoursForAllowancePage from './pages/HoursForAllowancePage';
import AdminSettingsPage from './pages/AdminSettingsPage';

function HomePlaceholder() {
  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>
        Optima Travel
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Welcome. This is an empty shell with base layout and login.
      </Typography>
    </Container>
  );
}

function App() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TravelAppBar />
      <Box component="main" sx={{ flex: 1, overflowX: 'hidden', width: '100%', maxWidth: '100%' }}>
        <Routes>
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/silent-renew" element={<SilentRenew />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><TravelsPage /></PrivateRoute>} />
          <Route path="/admin/vouchers" element={<PrivateRoute><VouchersPage /></PrivateRoute>} />
          <Route path="/admin/settings" element={<PrivateRoute><AdminSettingsPage /></PrivateRoute>} />
          <Route path="/admin/hours-for-allowance" element={<PrivateRoute><HoursForAllowancePage /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>
      <GlobalTooltip />
    </Box>
  );
}

export default App;
